import { gql } from '@apollo/client';

export const CREATE_BILLING_ADDRESS = gql`
  mutation Flex_CreateBillingAddressMutation($planId: Int!, $input: AddressInput!) {
    setBillingAddress(planId: $planId, input: $input) {
      success
    }
  }
`;
